module.exports = __webpack_public_path__ + "img/COMBO RADIO GREEN.bab1e47.svg";